import LayoutLogin from '../layouts/LayoutLogin.vue'

export default {
  path: '/',
  component: LayoutLogin,
  children: [
    {
      path: 'login',
      name: 'login',
      component: () => import('../views/auth/LoginView.vue'),
      meta: { 
        public: true, 
        skipAccessCheck: true 
      },
    },
    {
      path: '',
      redirect: '/login',
    },
  ],
}
